import { SavedBlockPoIsQuery } from '@/__generated__/graphql';
import {
  AnalysisCuboid,
  AnalysisCustomBlockWithFiles,
  CustomBlockDefects,
  CustomBlockQueryFilters,
} from '@/types';
import { StateMap } from '@/utils/stateMap';
import { atom } from 'jotai';

export const customBlockCuboids = atom<StateMap<string, AnalysisCuboid>>(
  new StateMap<string, AnalysisCuboid>()
);

export const showWorkscopeOverlayIcons = atom<boolean>(false);

export const selectedCustomBlock = atom<AnalysisCustomBlockWithFiles | undefined>(undefined);

export const hoveredCustomBlockId = atom<string | undefined>(undefined);

export const hoveredCustomBlock = atom<AnalysisCuboid | undefined>((get) => {
  const hoveredCustomBlockIdValue = get(hoveredCustomBlockId);
  const customBlockCuboidsValue = get(customBlockCuboids);

  if (!hoveredCustomBlockIdValue) return undefined;

  const found = customBlockCuboidsValue.get(hoveredCustomBlockIdValue);

  return found;
});

export const hoveredCustomBlockDefects = atom<CustomBlockDefects[0] | undefined>((get) => {
  const hoveredCustomBlockValue = get(hoveredCustomBlock);
  if (!hoveredCustomBlockValue) return;

  const allCustomBlocksValue = get(allCustomBlocks);
  const found = allCustomBlocksValue?.find(
    (item) => item.paintRegionId === hoveredCustomBlockValue.id
  );
  return found;
});

export const customBlocksQueryInput = atom<{
  hasMoreItems: boolean;
  page: number;
  sortBy: string | undefined;
  sortDir: number | undefined;
}>({
  hasMoreItems: true,
  page: 2,
  sortBy: undefined,
  sortDir: undefined,
});

export const selectedSavedBlockId = atom<string | undefined>(undefined);
export const allSavedBlocks = atom<SavedBlockPoIsQuery['pointOfInterests'] | undefined>();
export const allCustomBlocks = atom<CustomBlockDefects | undefined>();

// Storing all saved blocks in a map for faster access.
// Used for:
// - Getting paint region of a saved block when drawing a POI overlay in deckplan overlay
export const allSavedBlocksMap = atom<
  Map<string, SavedBlockPoIsQuery['pointOfInterests'][0] | undefined>
>((get) => {
  const map = new Map<string, SavedBlockPoIsQuery['pointOfInterests'][0]>();
  const blocksList = get(allSavedBlocks);
  if (!blocksList) return map;

  for (const item of blocksList) {
    map.set(item.id, item);
  }

  return map;
});
export const selectedSavedBlock = atom<SavedBlockPoIsQuery['pointOfInterests'][0] | undefined>(
  (get) => get(allSavedBlocks)?.find((block) => block.id === get(selectedSavedBlockId))
);

export const customBlockQueryFilters = atom<CustomBlockQueryFilters>({
  excludeAlreadyPlannedBlocks: true,
});
